import * as Sentry from '@sentry/nextjs';
import logger from '@/utils/logger';
import { useToast } from '@/hooks/useToast';
const PREFIX = 'features: WidgetEdit: hooks: useWidgetSaving:';

const useWidgetSaving = _ref => {
  let {
    isCreating,
    reportingWidget,
    createForProject,
    disableWorkbookSave,
    disableWidgetSave,
    workbookSave,
    widgetSave,
    onSuccess,
    onError
  } = _ref;
  const {
    addToast: sendNotification
  } = useToast(); // Save widget updates along with any
  // workbook updates that have not been
  // published yet

  const saveWidgetUpdates = async function (req) {
    let publish = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    const {
      workbookId,
      workbook,
      name: workbookName,
      workbookMeta,
      workbookFileOrigin,
      widget
    } = req;
    let saveWorkbookReq = Promise.resolve();
    let upsertedWorkbook = undefined; // Created or updated workbook

    if (!disableWorkbookSave) {
      var _reportingWidget$work;

      const targetWorkbookId = !isCreating && (reportingWidget === null || reportingWidget === void 0 ? void 0 : (_reportingWidget$work = reportingWidget.workbook) === null || _reportingWidget$work === void 0 ? void 0 : _reportingWidget$work.id) || workbookId || '';
      saveWorkbookReq = workbookSave({
        name: workbookName || '',
        widget,
        workbook,
        workbookMeta,
        workbookFileOrigin
      }, targetWorkbookId).catch(err => {
        logger.error(`${PREFIX} saveWorkbookUpdates: workbookSave: ${err}`);
        sendNotification({
          type: 'error',
          description: err.userMessage || 'Unexpected error saving workbook'
        });
        Sentry.captureException(Error(`${PREFIX}: saveWorkbookUpdates: workbookSave: ${err}`)); // Call error callback

        typeof onError === 'function' && onError(err, req);
      }); // Ensure latest workbook data
      // is available for the widget
      // if being published

      if (publish || isCreating) {
        upsertedWorkbook = await saveWorkbookReq;
      }
    } // Update widget if it has any user
    // updates and/or it's being re-published
    // NOTE: always send on creation or publish request


    if (disableWidgetSave && !publish) {
      return;
    }

    const updateWidgetReq = widgetSave({
      widget: widget,
      workbookId: upsertedWorkbook ? upsertedWorkbook.id : workbookId || '',
      projectId: createForProject,
      isCreating,
      isPublishing: isCreating ? false : publish
    }).catch(err => {
      logger.error(`${PREFIX} saveWorkbookUpdates: widgetSave: ${err}`);
      sendNotification({
        description: err.userMessage || 'Unexpected error saving widget',
        type: 'error'
      }); // Send error report

      Sentry.captureException(Error(`${PREFIX}: saveWorkbookUpdates: widgetSave: ${err}`)); // Call error callback

      typeof onError === 'function' && onError(err, req);
    });
    const results = await Promise.all([saveWorkbookReq, updateWidgetReq]);
    const [, upsertedWidget] = results; // Redirect user to their new widget

    if (upsertedWidget !== null && upsertedWidget !== void 0 && upsertedWidget.id) {
      typeof onSuccess === 'function' && onSuccess(upsertedWidget.id, req);
    }
  };

  return {
    saveWidgetUpdates
  };
};

export default useWidgetSaving;